import { LoadingState } from '../../../types/loading-state';
import { createFetchedData } from '../../../utils/fetched-data/create-fetched-data';
export const defaultMemberJourneysState = {
    current: createFetchedData(LoadingState.NotLoaded),
    past: createFetchedData(LoadingState.NotLoaded)
};
